module.exports = __webpack_public_path__ + "static/media/pencil.ec007c64.svg";